import moment from 'moment';
import { PeopleHRSyncTokenServerSide } from './people-hr-sync-token-server-side.model';

export class PeopleHRSyncToken {

  id: number;
  token: string;
  created: Date;
  lastSync: Date | null;

  constructor(peopleHRSyncTokenServerSide: PeopleHRSyncTokenServerSide) {
    this.id = peopleHRSyncTokenServerSide.id;
    this.token = peopleHRSyncTokenServerSide.token;
    this.created = moment.utc(peopleHRSyncTokenServerSide.created).toDate();
    this.lastSync = (peopleHRSyncTokenServerSide.lastSync === null ? null : moment.utc(peopleHRSyncTokenServerSide.lastSync).toDate());
  }

}